// iconSizes.js (optional helper)
export const ICON_SM = 14;   // layer panel buttons
export const ICON_MD = 16;   // toolbars
export const ICON_LG = 18;   // primary actions
